import ReactDOM from 'react-dom/client'
import { SnackbarProvider } from 'notistack'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './lib/env'
import { logSsoBootstrapOnLoad } from './sso/utils/sso-logger'
import './index.css'
import App from './App.tsx'
import { createTheme } from './theme/index.ts'
// import DbProvider from './contexts/db.context.tsx'
import AuthContextProvider from './contexts/auth.context.tsx'
import UserContextProvider from './contexts/user.context.tsx'
import SocketsContextProvider from './contexts/sockets.context.tsx'
import AppStateContextProvider from './contexts/app-state.context.tsx'
import DocumentsContextProvider from './contexts/documents.context.tsx'
import SecureStorageProvider from './contexts/secure-storage.context.tsx'
import NotificationsContextProvider from './contexts/notifications.context.tsx'
import NavigationHistoryProvider from './contexts/navigation-history.context.tsx'
import { SuiteAuthProvider } from './sso/contexts/suite-auth.context.tsx'
import CreatingReport from './components/customer-company-details-management/creating-report.tsx'
import ReportComplete from './components/customer-company-details-management/report-complete.tsx'
import CreatingReportDelay from './components/customer-company-details-management/creating-report-delay.tsx'
import ErrorCreatingReport from './components/customer-company-details-management/error-creating-report.tsx'
// import { PowerSyncProvider } from './contexts/PowerSyncProvider.tsx'

logSsoBootstrapOnLoad()

const theme = createTheme()
const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

declare module 'notistack' {
  interface VariantOverrides {
    creatingReport: true
    reportComplete: true
    creatingReportDelay: true
    errorCreatingReport: true
  }
}

root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <NavigationHistoryProvider.Provider>
        <AuthContextProvider.Provider>
          {/* <DbProvider.Provider> */}
          <UserContextProvider.Provider>
            <DocumentsContextProvider.Provider>
              <SocketsContextProvider.Provider>
                <SnackbarProvider
                  maxSnack={3}
                  autoHideDuration={5000}
                  Components={{
                    creatingReport: CreatingReport,
                    reportComplete: ReportComplete,
                    creatingReportDelay: CreatingReportDelay,
                    errorCreatingReport: ErrorCreatingReport
                  }}
                >
                  {/* <PowerSyncProvider> */}
                  <AppStateContextProvider.Provider>
                    <NotificationsContextProvider.Provider>
                      <SecureStorageProvider.Provider>
                        <QueryClientProvider client={queryClient}>
                          <SuiteAuthProvider>
                            <App />
                          </SuiteAuthProvider>
                        </QueryClientProvider>
                      </SecureStorageProvider.Provider>
                    </NotificationsContextProvider.Provider>
                  </AppStateContextProvider.Provider>
                  {/* </PowerSyncProvider> */}
                </SnackbarProvider>
              </SocketsContextProvider.Provider>
            </DocumentsContextProvider.Provider>
          </UserContextProvider.Provider>
          {/* </DbProvider.Provider> */}
        </AuthContextProvider.Provider>
      </NavigationHistoryProvider.Provider>
    </BrowserRouter>
  </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
